import React from 'react';
import { node, string } from 'prop-types';

import Paper from '@material-ui/core/Paper';

import classes from './SidebarPanel.module.css';

const SidebarPanel = ({ children, id, title, titleIconSrc }) => (
    <Paper className={classes.sidebar}>
        <header className={classes.header}>
            <img alt="" src={titleIconSrc} />
            <span id={id}>{title}</span>
        </header>
        {children}
    </Paper>
);

SidebarPanel.propTypes = {
    children:     node,
    id:           string,
    title:        string.isRequired,
    titleIconSrc: string
};

export default SidebarPanel;
